import { buildUrl } from 'cloudinary-build-url';

class CloudinaryService {
  cloud;

  constructor() {
    this.cloud = { cloudName: 'codealodev' }
  }

  buildUrl(publicId: string, transformation: object) {
    return buildUrl(publicId, { transformation, cloud: this.cloud });
  }
}

export default new CloudinaryService();